module.exports = __webpack_public_path__ + "img/logo.ebc97331.png";